// extracted by mini-css-extract-plugin
export default {"Name":"UserInfo_Name__29Wg+","Name--light":"UserInfo_Name--light__B8pi+","Name--dark":"UserInfo_Name--dark__Dwo89"};